import { render, staticRenderFns } from "./RentToOwnNumberChip.vue?vue&type=template&id=874f569e&scoped=true"
import script from "./RentToOwnNumberChip.vue?vue&type=script&lang=js"
export * from "./RentToOwnNumberChip.vue?vue&type=script&lang=js"
import style0 from "./RentToOwnNumberChip.vue?vue&type=style&index=0&id=874f569e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874f569e",
  null
  
)

export default component.exports